export * from './paginator.component';
export * from './paginator.module';
